import { BarChart3Icon } from "lucide-react";

interface EmptyChartProps {
  message: string;
  hint?: string;
}

export function EmptyChart({ message, hint }: EmptyChartProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center border rounded-lg bg-muted/20">
      <BarChart3Icon className="h-10 w-10 text-muted-foreground/40 mb-3" />
      <p className="text-sm font-medium text-muted-foreground">{message}</p>
      {hint && (
        <p className="text-xs text-muted-foreground/70 mt-1 max-w-sm">{hint}</p>
      )}
    </div>
  );
}
